module.exports = __webpack_public_path__ + "static/media/team-carl.7dafee18.jpg";